import { ReactElement, useContext } from "react"

import { SYS_ADMIN_LCT_STEPS } from "../../../../../constants/lct/evac/deviceForm"
import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { CreateAcuDeviceContext } from "../providers/baseProviders/createAcuDeviceProvider"

const NON_SYS_ADMIN_ACU_STEPS = [
    "Core Air Conditioning Unit Details",
    "Upload Supporting Files",
    "Review and Submit",
]

/** AppStepper for Air Conditioning Unit device creation */
const CreateAcuDeviceProgressStepper = (): ReactElement => {
    const { currentIndex, canEditManufacturer } = useContext(
        CreateAcuDeviceContext
    )

    const steps = canEditManufacturer
        ? [...SYS_ADMIN_LCT_STEPS, ...NON_SYS_ADMIN_ACU_STEPS]
        : NON_SYS_ADMIN_ACU_STEPS

    return <AppStepper stepLabels={steps} currentStepIndex={currentIndex} />
}

export default CreateAcuDeviceProgressStepper
